'use strict';

define(['utils/strings'], function (strings) {
    return {
        localName: function localName(node) {
            if (!node) {
                return '';
            } else if (node.localName) {
                return node.localName;
            } else if (node.baseName) {
                return node.baseName;
            } else {
                return '';
            }
        },
        textContent: function textContent(node) {
            if (!node) {
                return '';
            } else if (node.textContent) {
                return strings.trim(node.textContent);
            } else if (node.text) {
                return strings.trim(node.text);
            } else {
                return '';
            }
        },
        getChildNode: function getChildNode(parent, index) {
            return parent.childNodes[index];
        },
        numChildren: function numChildren(parent) {
            if (parent.childNodes) {
                return parent.childNodes.length;
            } else {
                return 0;
            }
        }

    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/parsers/parsers.js
 ** module id = 84
 ** module chunks = 0
 **/